import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';

export default class CenterInfoStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  //----------------------------------
  /* 화면 변경 목록, 상세보기, 수정, 추가 */
  @observable
  _viewMode = 'list';

  @computed
  get viewMode() {
    return this._viewMode;
  }

  @action
  onViewMode = (mode) => {
    // list, detail, add, mod
    this._viewMode = mode;
    if (mode === 'add') {
      this._valCondition.checkCeCd = false;
      this._detailData = null;
    }
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    ceCd: '',
    ceNm: '',
    ceUseYn: '',
    ceBranchCd: '',

    pageIdx: 1,
    recordCountPerPage: 10,
    checkCeCd: false
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = null;

  @computed
  get detailData() {
    return this._detailData;
  }

  @action
  onDetailData = (deta) => {
    if (deta !== null) {
      this._viewMode = 'detail';
    }
    this._detailData = deta;
  };
  //----------------------------------
  @observable
  _centerList = [];

  @computed
  get centerList() {
    return this._centerList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }

  @action
  onClear = () => {
    this._viewMode = 'list';
    
    this._centerList = [];
    this._pageInfo = null;
    this._detailData = null;
    this._valCondition = {
      ceCd: '',
      ceNm: '',
      ceUseYn: '',
      ceBranchCd: '',

      pageIdx: 1,
      recordCountPerPage: 10,
      checkCeCd: false
    };

    this._branchList = [];
    this._pageInfoBranch = null;
  };

  //----------------------------------
  @action
  disCenterList = async (pageIdx, recordCountPerPage, ceUseYn) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    if (ceUseYn !== undefined && ceUseYn !== null && this._valCondition.ceUseYn !== ceUseYn) {
      this._valCondition.ceUseYn = ceUseYn;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-CENTER-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceNm', paraValue: this._valCondition.ceNm});
    reqInputMsg.addParam({paraName: 'ceUseYn', paraValue: this._valCondition.ceUseYn});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._centerList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._centerList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._centerList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  @action
  disCenterCheck = async (chkData) => {
    let addition = new Addition();
    addition.setCmdName('DIS-CENTER-CHECK');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: chkData});
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result.length > 0) {
            notification.error({placement: 'bottomLeft', message: `중복된 코드가 있습니다.`, duration: 2});
          } else {
            notification.success({placement: 'bottomLeft', message: `추가 가능한 코드 입니다.`, duration: 2});
            this._valCondition.checkCeCd = true;
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`중복된체크가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`중복된체크가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @observable
  _excelUploadIng = false;

  @computed
  get excelUploadIng() {
    return this._excelUploadIng;
  }

  @action
  onExcelUploadIng = (boolen) => {
    this._excelUploadIng = boolen;
  }

  @action
  merCenterList = async (uploadList) => {
    if (uploadList.length <= 0) {
      notification.error({placement: 'bottomLeft', message:`데이터가 없습니다. 파일을 확인하세요..`, duration: 2});
      return;
    }

    this._excelUploadIng = true;
    let addition = new Addition();
    addition.setCmdName('MER-CENTER-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'uploadList', paraValue: uploadList});
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._excelUploadIng = false;
            this._viewMode = 'list';
            this.disCenterList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
            this._excelUploadIng = false;
          }
        } else if (res.error.code === '0003') {
          this._excelUploadIng = false;
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._excelUploadIng = false;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._excelUploadIng = false;
        console.log('error', error);
      });
  };

  @action
  addCenterInfo = async (data) => {
    // data.ceAddr = data.ceAddr1 + '/n' + data.ceAddr2;
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});

    // console.log(paramData);

    let addition = new Addition();
    addition.setCmdName('ADD-CENTER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disCenterList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  modCenterInfo = async (data) => {
    // data.ceAddr = data.ceAddr1 + '/n' + data.ceAddr2;
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});
    //console.log('paramData', paramData);

    let addition = new Addition();
    addition.setCmdName('MOD-CENTER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this._viewMode = 'detail';
            this._detailData = data;
            this.disCenterList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });

  };

  @action
  useCenterYn = async (ceCd, ceUseYn) => {
    let addition = new Addition();
    addition.setCmdName('USE-CENTER-YN');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: ceCd});
    reqInputMsg.addParam({paraName: 'ceUseYn', paraValue: ceUseYn === 'Y' ? 'N' : 'Y'});
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정에 성공하였습니다.`, duration: 2});
            this._detailData = null;
            this._viewMode = 'list';
            this.disCenterList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  disPwReset = async (ceCd) => {
    let addition = new Addition();
    addition.setCmdName('DIS-PW-RESET');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: ceCd});
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`초기화에 성공하였습니다.`, duration: 2});
          } else {
            notification.success({placement: 'bottomLeft', message:`초기화에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`초기화에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`초기화에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };
}
  
